import { useSelector } from "react-redux";

export default function useRoomDetails(roomId) {
  const roomDetails = useSelector((state) => state.lobby?.masterRoomsObject[roomId]);

  if (!roomDetails || !roomId) {
    // console.error('Error! No room id found in useRoomDetails. ', roomId);
    return {};
  }

  return roomDetails;
}
